import { createContext, useContext, useEffect, useState } from "react";
import { DA_SITE } from "@/data/daSite";

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (s) => s });
const KEY = "sn_lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => (/for=(kolding|proces)/.test(window.location.search) ? "da" : localStorage.getItem(KEY) || "en"));
  const setLang = (l) => {
    localStorage.setItem(KEY, l);
    setLangState(l);
  };
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (s) => (lang === "da" && typeof s === "string" ? DA_SITE[s] ?? s : s);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

// Renders a translatable string; *word* becomes a marker highlight.
export function T({ children, className }) {
  const { t } = useLang();
  const parts = t(children).split("*");
  return (
    <span className={className}>
      {parts.map((p, i) => (i % 2 ? <span key={i} className="marker">{p}</span> : p))}
    </span>
  );
}
